import { gql } from '@/__generated__';
import { GetHardDeleteUserPreviewQuery } from '@/__generated__/graphql';

export type HardDeleteUserPreview = GetHardDeleteUserPreviewQuery['hardDeleteUserPreview'];

const GET_HARD_DELETE_USER_PREVIEW = gql(`#graphql
  query GetHardDeleteUserPreview($userId: Int!) {
    hardDeleteUserPreview(userId: $userId) {
      userId
      account {
        id
        fullName
        email
        deletedAt
      }
      affectedTables {
        table
        count
        preserved
      }
    }
  }
`);

export default GET_HARD_DELETE_USER_PREVIEW;
